import React from "react";
import icon from ".././../assets/icons/Marker.svg"
const Marker = props => {
    return <div className="SuperAwesomePin">
      <img src={icon} alt = "marker" height={29} width={24}></img>
    </div>
  }

  export default Marker;